<div class="top-bar">
    <div class="left">
        <img src="../../../assets/tco_logo50x117.png" class="header-logo" />
        <span class="app-title">TCO FDM</span>
    </div>
    <!-- <div class="right">
        <button mat-icon-button matToolTip="Settings">
            <mat-icon>settings</mat-icon>
        </button>
        <button mat-icon-button matToolTip="Help">
            <mat-icon>help_outline</mat-icon>
        </button>
        <div class="user-avatar">YZ</div>
    </div> -->
</div>
